export function AddSpinnerPage({ createSpinner }) {
  return (
    <div className="sidecontent AddSpinnerPage">
      <input
        id="add-spinner-name-input"
        placeholder="Spinner Name"
        autoComplete="off"
      />
      <textarea id="add-spinner-values-textarea" placeholder="Spinner Values" />
      <button
        onClick={() => {
          const spinnerName = document
            .getElementById("add-spinner-name-input")
            .value.trim();

          const spinnerValues = document
            .getElementById("add-spinner-values-textarea")
            .value.split("\n")
            .map((s) => s.trim())
            .filter((b) => b.length > 0);

          if (spinnerName && spinnerValues) {
            createSpinner(spinnerName, spinnerValues);
          }
        }}
      >
        Submit
      </button>
    </div>
  );
}
